import React, { PureComponent } from "react";
import ReactWOW from 'react-wow';
import { $t } from '@/modules/i18n';

class Logo extends PureComponent {
  render() {
    return (
      <a href={this.props.link} target="_blank" rel="noopener noreferrer" className="link">
        <img src={require("@ndsc/assets/images/partners/" + this.props.image)} alt={this.props.name} className="img-logo" />
        <p className="name">{this.props.name}</p>
      </a>
    )
  }
}

class Partners extends React.Component {
  render() {
    const msg = this.props.Message;
    const partners = [{
      title: msg.trainingPartners,
      datas: msg.trainingPartnersData
    }, {
      title: msg.universityPartners,
      datas: msg.universityPartnersData
    }, {
      title: msg.supportPartners,
      datas: msg.supportPartnersData
    }, {
      title: msg.studentPartners,
      datas: msg.studentPartnersData
    }]
    return (
      <section id="partners">
        <div className="container">
          <div className="title-block">
            <h2>{$t(msg.partners)}</h2>
          </div>
          {
            partners.map(partner => (
              <div key={partner.title}>
                <h5>{$t(partner.title)}</h5>
                <div className="grid-container">
                  {
                    (partner.datas || []).map((item, index) => {
                      return (
                        <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                          <div className="grid-item">
                            <Logo
                              name={$t(item.name)}
                              image={item.image}
                              link={item.link}
                            />
                          </div>
                        </ReactWOW>
                      )
                    })
                  }
                </div>
              </div>
            ))
          }
        </div>
      </section>
    );
  }
}

export default Partners;